module.exports = __webpack_public_path__ + "static/imgs/price.11c5036.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/price.jpg
// module id = 1uRP
// module chunks = 1